import React from 'react';
import { AboutSection } from '../components/AboutSection';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { CTABanner } from '../components/CTABanner';
export function AboutPage() {
  return <main data-id="element-229">
      {/* Hero Banner */}
      <section className="bg-slate-900 py-20 text-center px-4" data-id="element-230">
        <div className="container mx-auto max-w-3xl" data-id="element-231">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-232">
            About Us
          </h1>
          <p className="text-xl text-slate-300" data-id="element-233">
            The UK's trusted emergency courier providers — supplying
            professional drivers for hire and delivering items nationwide.
          </p>
        </div>
      </section>

      <AboutSection data-id="element-234" />
      <WhyChooseUs data-id="element-235" />

      {/* Mission & Values */}
      <section className="py-20 bg-white" data-id="element-236">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-237">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-238">
            <div data-id="element-239">
              <h2 className="text-3xl font-bold text-slate-900 mb-6" data-id="element-240">
                Our Mission
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-241">
                To be the UK's most reliable emergency courier provider,
                supplying professional drivers for hire and delivering items
                with the utmost care, speed, and professionalism. Whether
                businesses need a driver at short notice or individuals need an
                urgent delivery, we strive to be the partner you can always
                count on.
              </p>
            </div>
            <div data-id="element-242">
              <h2 className="text-3xl font-bold text-slate-900 mb-6" data-id="element-243">
                Our Values
              </h2>
              <ul className="space-y-4 text-slate-600" data-id="element-244">
                <li data-id="element-245">
                  <strong className="text-slate-900" data-id="element-246">Reliability:</strong> We
                  deliver on our promises, every time.
                </li>
                <li data-id="element-247">
                  <strong className="text-slate-900" data-id="element-248">Speed:</strong> Rapid
                  response times for emergency needs.
                </li>
                <li data-id="element-249">
                  <strong className="text-slate-900" data-id="element-250">Professionalism:</strong>{' '}
                  Vetted, experienced drivers and staff.
                </li>
                <li data-id="element-251">
                  <strong className="text-slate-900" data-id="element-252">Care:</strong> Treating
                  your items as if they were our own.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <CTABanner data-id="element-253" />
    </main>;
}